/* PDP layout enhancement: cleaner product page + cross-sell recommendations */
(function(){
  const money = (value) => {
    if (value == null || value === '') return '';

    if (typeof value === 'number') {
      return new Intl.NumberFormat('lt-LT', { style: 'currency', currency: 'EUR' }).format(value / 100);
    }

    const raw = String(value).trim();
    if (!raw) return '';

    if (raw.includes('€')) return raw;

    const normalized = Number(raw.replace(',', '.'));
    if (Number.isNaN(normalized)) return raw;

    if (raw.includes('.') || raw.includes(',')) {
      return new Intl.NumberFormat('lt-LT', { style: 'currency', currency: 'EUR' }).format(normalized);
    }

    return new Intl.NumberFormat('lt-LT', { style: 'currency', currency: 'EUR' }).format(normalized / 100);
  };

  const escapeHTML = (value) => String(value || '').replace(/[&<>"']/g, (ch) => ({
    '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'
  }[ch]));

  function imageUrlFrom(value){
    if (!value) return '';

    if (typeof value === 'string') {
      return value.startsWith('//') ? `https:${value}` : value;
    }

    if (typeof value === 'object') {
      const src = value.src || value.url || value.preview_image?.src || value.featured_image?.src || '';
      return src ? imageUrlFrom(src) : '';
    }

    return '';
  }

  function priceFromProduct(product){
    const variant = Array.isArray(product.variants) && product.variants.length ? product.variants[0] : null;
    return money(product.price || product.price_min || variant?.price || variant?.compare_at_price || '');
  }

  function removeOldInjectedBlocks(){
    document.querySelectorAll('.pdp-gallery-info, .pdp-gallery-accordion').forEach((el) => el.remove());
  }

  function moveTrustBadgesUnderGallery(){
    const gallery = document.querySelector('.pdp .gal');
    const badges = document.querySelector('.pdp .pinfo .p-badges');
    if (!gallery || !badges) return;

    if (badges.parentElement === gallery) return;

    badges.classList.add('p-badges--under-gallery');
    gallery.appendChild(badges);
  }

  function normalizeProduct(product){
    const image = imageUrlFrom(
      product.featured_image ||
      product.image ||
      product.featured_media ||
      (Array.isArray(product.images) ? product.images[0] : '')
    );
    const url = product.url || (product.handle ? `/products/${product.handle}` : '#');
    const price = priceFromProduct(product);

    return {
      title: product.title || 'Dovana',
      url,
      image,
      price,
      handle: product.handle || ''
    };
  }

  function renderCard(product){
    const item = normalizeProduct(product);
    return `
      <article class="pdp-cross-card">
        <a class="pdp-cross-card__media" href="${escapeHTML(item.url)}" aria-label="${escapeHTML(item.title)}">
          ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" loading="lazy">` : `<span aria-hidden="true">♡</span>`}
        </a>
        <div class="pdp-cross-card__body">
          <h3><a href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a></h3>
          ${item.price ? `<p>${escapeHTML(item.price)}</p>` : ''}
        </div>
      </article>
    `;
  }

  async function fetchRecommendations(productId){
    const urls = [
      `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=4`,
      `/collections/all/products.json?limit=8`
    ];

    for (const url of urls) {
      try {
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) continue;
        const data = await res.json();
        const products = Array.isArray(data.products) ? data.products : [];
        const filtered = products.filter((p) => String(p.id) !== String(productId)).slice(0, 4);
        if (filtered.length) return filtered;
      } catch (e) {}
    }
    return [];
  }

  function ensureCrossSellShell(){
    const productPage = document.querySelector('.pdp');
    if (!productPage || document.querySelector('[data-pdp-cross-sell]')) return null;

    const section = document.createElement('section');
    section.className = 'pdp-cross-sell';
    section.setAttribute('data-pdp-cross-sell', '');
    section.innerHTML = `
      <div class="container">
        <div class="pdp-cross-shell">
          <div class="pdp-cross-head">
            <div>
              <span class="eyebrow">Papildykite dovaną</span>
              <h2>Dažnai perkama kartu</h2>
              <p>Mažos detalės, kurios dovaną padaro šiltesnę ir labiau asmenišką.</p>
            </div>
            <a href="/collections/all" class="sec-link">Peržiūrėti visas dovanas</a>
          </div>
          <div class="pdp-cross-grid" aria-live="polite">
            <div class="pdp-cross-loading">Ieškome tinkamų dovanų...</div>
          </div>
        </div>
      </div>
    `;

    const support = document.querySelector('.pdp-inline-support');
    if (support) support.parentNode.insertBefore(section, support);
    else productPage.insertAdjacentElement('afterend', section);
    return section;
  }

  async function initCrossSell(){
    const productPage = document.querySelector('.pdp');
    if (!productPage) return;
    const productId = productPage.getAttribute('data-product-id');
    const section = ensureCrossSellShell();
    if (!section || !productId) return;

    const grid = section.querySelector('.pdp-cross-grid');
    const products = await fetchRecommendations(productId);

    if (!products.length) {
      section.remove();
      return;
    }

    grid.innerHTML = products.map(renderCard).join('');
  }

  function polishLabels(){
    document.querySelectorAll('.acc-title').forEach((el) => {
      const text = (el.textContent || '').trim();
      if (text === 'Kodėl ši dovana ypatinga') el.textContent = 'Kodėl tai gera dovana';
    });

    document.querySelectorAll('.pdp-related-inline .sec-hdr h2').forEach((el) => {
      el.textContent = 'Derėtų prie šios dovanos';
    });
  }

  function initPdpLayout(){
    removeOldInjectedBlocks();
    moveTrustBadgesUnderGallery();
    polishLabels();
    initCrossSell();
  }

  document.addEventListener('DOMContentLoaded', initPdpLayout);
  document.addEventListener('shopify:section:load', initPdpLayout);
})();
